import goodWeMiniLogo from "../assets/images/good_we_mini_logo.svg";
import vRMiniLogo from "../assets/images/vrm_mini_logo.svg";
import { ESolarServiceProvider } from "../enums/solar-service-provider";

export const getServiceProviderLogo = (
  serviceProvider: ESolarServiceProvider
): string => {
  switch (serviceProvider) {
    case ESolarServiceProvider.VRM:
      return vRMiniLogo;
    case ESolarServiceProvider.GOODWE:
      return goodWeMiniLogo;
    default:
      return "";
  }
};
